import { render, staticRenderFns } from "./m-conflict-table.vue?vue&type=template&id=1c873634&scoped=true&"
import script from "./m-conflict-table.vue?vue&type=script&setup=true&lang=ts&"
export * from "./m-conflict-table.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./m-conflict-table.vue?vue&type=style&index=0&id=1c873634&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c873634",
  null
  
)

export default component.exports